import { Box } from "@mui/material";
import React from "react";

export interface IAdminWorkspaceWrapper 
{
    children: React.ReactNode;
}

export const AdminWorkspaceWrapper: React.FC<IAdminWorkspaceWrapper> = ({
    children
}) => {
    return (
        <Box sx={{
                padding: '30px',
                backgroundColor: '#F7F8FA',
                height: '100%'
            }}>
            <Box sx={{
                background: '#FFFFFF 0% 0% no-repeat padding-box',
                border: '1px solid #0000001A',
                borderRadius: '4px',
                padding: '30px',
            }}>
                { children }
            </Box>
        </Box>
    )
}